import {observer} from 'mobx-react-lite'
import React from 'react'
import {Avatar} from '@components/common/base/avatar'
import {cn} from '@containers/html-utils'
import {PersonalChatProxy} from '@extensions/proxies/personal-chat-proxy'
import {gotoUser} from '../../handlers/main-handlers'
import {TwChatItemText, TwItem, TwMsgCount} from './containers'

export const PersonalProjectListItem = observer(
  ({u}: {u: PersonalChatProxy}) => {
    const msgCount = u.messagesCount
    const newMsgCount = u.newMessagesAmount

    const hasNewMsg = newMsgCount > 0
    const count = newMsgCount > 0 ? newMsgCount : msgCount
    const markImportant = !!u.markImportant

    return (
      <TwItem onClick={() => gotoUser(u)}>
        <Avatar size={16} userId={u.userId} hideOutline hideHint />

        <TwChatItemText>{u.userName}</TwChatItemText>

        {markImportant && (
          <TwMsgCount className={cn('ml-auto')} $hasNewMsg={true}>
            {'!'}
          </TwMsgCount>
        )}

        <TwMsgCount
          className={cn(!markImportant && 'ml-auto')}
          $hasNewMsg={hasNewMsg}
        >
          {count}
        </TwMsgCount>
      </TwItem>
    )
  }
)
